import { render, staticRenderFns } from "./datatable-search.vue?vue&type=template&id=313ca1d4&scoped=true&"
import script from "./datatable-search.vue?vue&type=script&lang=ts&"
export * from "./datatable-search.vue?vue&type=script&lang=ts&"
import style0 from "./datatable-search.vue?vue&type=style&index=0&id=313ca1d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ca1d4",
  null
  
)

export default component.exports